import React from "react";
import styled from "styled-components";

const ProgressContainer = styled.div`
  position: relative;
  width: 100%;
  height: 8px;

  /* This is the 0–100% lifetime gradient */
  background: linear-gradient(
    90deg,
    #6678ea 0%,
    #6678ea 70%,
    #d6cd5d 80%,
    #f17a69 95%,
    #f17a69 100%
  );

  border-radius: 999px;
  overflow: hidden;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.7);
`;

const ProgressCover = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;

  width: ${({ progress }) => `${100 - progress}%`};

  background: linear-gradient(
    to left,
    #111827 0%,
    #111827 85%,
    rgba(17, 24, 39, 0.7) 92%,
    rgba(17, 24, 39, 0.0) 100%
  );

  transition: width 0.3s ease-in-out;
`;

const ProgressGlow = styled.div`
  position: absolute;
  inset: 0;
  box-shadow:
    0 0 6px rgba(102, 120, 234, 0.45),
    0 0 10px rgba(241, 122, 105, 0.25);
  pointer-events: none;
`;

const ProgressText = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 9px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.7);
  pointer-events: none;
`;

function ProgressBar({ progress }) {


  const clampedProgress = Math.min(100, Math.max(0, progress));

  return (
        <ProgressContainer>
        <ProgressCover progress={clampedProgress} />
        <ProgressGlow />
        <ProgressText>{clampedProgress}%</ProgressText>
        </ProgressContainer>
  );
}

export default ProgressBar;